// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { useEffect } from 'react';

import { useCookieConsent } from '@/hooks/use-cookie-consent';

import { LegalDocumentsConsentModal } from '@/features/user/components/legal-documents-consent-modal';
import { useLegalDocuments } from '@/features/user/hooks/use-legal-documents';
import { useSyncCaptchaConsent } from '@/features/user/hooks/use-sync-captcha-consent';
import { useSyncCookieConsent } from '@/features/user/hooks/use-sync-cookie-consent';

import { CookieDialog } from '@/components/cookie-dialog/cookie-dialog';
import { Loader } from '@/components/loader/loader';

import { loadAnalyticsScripts } from '@/lib/analytics/analytics-loader';
import { Toaster } from '@/lib/shadcn/components/ui/toaster/toaster';

import { AppProvider } from './provider';
import { RouterProvider } from './router';

// import { TanStackRouterDevelopmentTools } from "./components/utils/development-tools/TanStackRouterDevelopmentTools";

const LegalDocumentsInit = () => {
  useLegalDocuments();
  return null;
};

const CookieConsentSyncInit = () => {
  useSyncCookieConsent();
  return null;
};

const CaptchaConsentSyncInit = () => {
  useSyncCaptchaConsent();
  return null;
};

const AnalyticsInit = () => {
  const { analyticsAccepted } = useCookieConsent();

  useEffect(() => {
    loadAnalyticsScripts(analyticsAccepted);
  }, [analyticsAccepted]);

  return null;
};

export const App = () => {
  return (
    <AppProvider>
      <LegalDocumentsInit />
      <CookieConsentSyncInit />
      <CaptchaConsentSyncInit />
      <AnalyticsInit />
      <RouterProvider />
      <Loader />
      <CookieDialog />
      <LegalDocumentsConsentModal />
      {/* <TanStackRouterDevelopmentTools
				router={router}
				initialIsOpen={false}
				position="bottom-right"
			/> */}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <Toaster
        position="bottom-center"
        duration={2000}
        visibleToasts={1}
        offset={{ bottom: 158 }}
        mobileOffset={{ bottom: 158 }}
        toastOptions={{
          classNames: {
            toast:
              'flex items-center justify-center w-fit !rounded-large px-6 !py-unit-4',
          },
        }}
      />
    </AppProvider>
  );
};
